import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

export default function Loading() {
  return (
    <Box m={2}>
      <CircularProgress size={24} />    
    </Box>
  );
}